/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'branch': {
    width: 200,
    height: 200,
    viewBox: '0 0 1024 1024',
    data: '<defs/><path pid="0" d="M768 640a128 128 0 00-89.6 36.693L341.333 526.507V497.92L678.4 347.307A128 128 0 10640 256v14.507L302.933 420.693a128 128 0 100 182.614L640 753.92V768a128 128 0 10128-128z" _fill="#555"/>'
  }
})
